import Api from "../index";
import { endPoints, requestType } from "../../constants/variables";

export const getAllCategories = (id) => {
  return Api(`${endPoints.getCategories}/${id}`, null, requestType.GET);
};
export const getAdminCategories = (id) => {
  return Api(`${endPoints.getCategoryByAdmin}`, null, requestType.GET);
};

export const editCategory = (id, params) => {
  return Api(`${endPoints.editCategory}/${id}`, params, requestType.PUT);
};

export const addCategory = (params) => {
  return Api(endPoints.addCategory, params, requestType.POST);
};

export const deleteCategory = (id) => {
  return Api(`${endPoints.deleteCategory}/${id}`, null, requestType.DELETE);
};

export const updateCategoryStatus = (params) => {
  return Api(`${endPoints.updateRequestedCategory}`, params, requestType.POST);
};

export const updateCategoryStatusRejected = (params) => {
  return Api(
    `${endPoints.updateRequestedCategoryReject}`,
    params,
    requestType.POST
  );
};
